import adjustViewport from './function/adjustViewport'

import Drawer from './module/Drawer';
import SmoothScroll from './module/SmoothScroll';
import CopyToClipboard from './module/CopyToClipboard';
import IntersectionObserverHeaderAnima from './module/IntersectionObserverHeaderAnima';
import IntersectionObserverScrollAnima from './module/IntersectionObserverScrollAnima';

import PageTop from './pages/top';
import PageAbout from './pages/about';

// ブレイクポイント
const bp = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};

const init = () => {
  (() => {
    const headerDrawerMenu = new Drawer({
      drawer: '#js-drawer-menu',
      drawerOpenBtn: '#js-drawer-menu-open-btn',
      drawerCloseBtn: '#js-drawer-menu-close-btn',
      drawerBg: false
    });
    headerDrawerMenu.init();
  })();

  (() => {
    const smoothScroll = new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
    smoothScroll.init();
  })();

  (() => {
    const copyToClipboardArticleURL = new CopyToClipboard({
      copyBtn: '[data-url-copy-btn]',
    });
    copyToClipboardArticleURL.init();
  })();

  (() => {
    if (document.querySelector('#js-error-page')) return; // エラーページでは実行しない
    const intersectionObserverHeaderAnima = new IntersectionObserverHeaderAnima();
    intersectionObserverHeaderAnima.init();
  })();

  (() => {
    const intersectionObserverScrollAnima = new IntersectionObserverScrollAnima();
    intersectionObserverScrollAnima.init();
  })();

  // (() => {
  //   const pageTop = new PageTop();
  //   pageTop.init();
  // })();

  (() => {
    const pageAbout = new PageAbout();
    pageAbout.init();
  })();

};

window.addEventListener('DOMContentLoaded', () => {
  adjustViewport();
  init();
});


